export type PackagingItemSupplierFilterOption = {
  id: string
  name: string
}

export function packagingItemMatchesSupplierFilter(
  supplierId: string,
  filterValue: unknown
): boolean {
  if (typeof filterValue !== 'string' || filterValue.trim() === '') {
    return true
  }
  return supplierId === filterValue.trim()
}

export function buildPackagingItemSupplierFilterOptions(
  rows: Array<{ supplierId: string; supplierName: string }>
): PackagingItemSupplierFilterOption[] {
  const byId = new Map<string, PackagingItemSupplierFilterOption>()
  for (const row of rows) {
    if (byId.has(row.supplierId)) {
      continue
    }
    byId.set(row.supplierId, {
      id: row.supplierId,
      name: row.supplierName,
    })
  }
  return Array.from(byId.values()).sort((left, right) =>
    left.name.localeCompare(right.name)
  )
}

export function filterPackagingItemSupplierOptions(
  options: PackagingItemSupplierFilterOption[],
  query: string
): PackagingItemSupplierFilterOption[] {
  const normalizedQuery = query.trim().toLowerCase()
  if (normalizedQuery === '') {
    return options
  }
  return options.filter((option) =>
    option.name.toLowerCase().includes(normalizedQuery)
  )
}

export function ensureSelectedSupplierOption(
  options: PackagingItemSupplierFilterOption[],
  selectedId: string | null,
  selectedNameFallback?: string
): PackagingItemSupplierFilterOption[] {
  if (selectedId == null || selectedId === '') {
    return options
  }
  if (options.some((option) => option.id === selectedId)) {
    return options
  }
  return [
    {
      id: selectedId,
      name: selectedNameFallback?.trim() || selectedId,
    },
    ...options,
  ]
}
